module.exports = __webpack_public_path__ + "static/media/celebDOA.f3fa245b.gif";